module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-22.2c9b09e0.jpg";